import { AxiosResponse } from 'axios';
import { snakeCaseKeys } from 'helpers/utils';
import { get, post, remove } from 'services/api';
import { IReservationsFormData } from 'views/public/ReservationsView/components/ReservationsForm/types';

export const getAll = (
  limit: number,
  page: number,
  search: string,
  sortKey: string,
  sortType: string,
): Promise<AxiosResponse> =>
  get(
    `reservations?limit=${limit}&page=${page}&search=${search}&sortKey=${sortKey}&sortType=${sortType}`,
  );

export const getForm = (): Promise<AxiosResponse> => get('reservations/form');

export const getOne = (id: string): Promise<AxiosResponse> => get(`reservations/${id}`);

export const save = (data: IReservationsFormData, id: string): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append(
    'person',
    JSON.stringify(snakeCaseKeys(data.person as unknown as Record<string, unknown>)),
  );
  if (data.person?.idCardFile) formData.append('person_id_card_file', data.person.idCardFile);
  if (data.person?.idCardBackFile)
    formData.append('person_id_card_back_file', data.person.idCardBackFile);
  if (data.person?.ketubaFile) formData.append('person_ketuba_file', data.person.ketubaFile);
  if (data.person?.marriageCertificateFile)
    formData.append('person_marriage_certificate_file', data.person.marriageCertificateFile);
  if (data.person?.getFile) formData.append('person_get_file', data.person.getFile);
  formData.append(
    'family',
    JSON.stringify(snakeCaseKeys(data.family as unknown as Record<string, unknown>)),
  );
  formData.append(
    'location',
    JSON.stringify(snakeCaseKeys(data.location as unknown as Record<string, unknown>)),
  );
  formData.append(
    'manager',
    JSON.stringify(snakeCaseKeys(data.manager as unknown as Record<string, unknown>)),
  );
  if (data.manager?.idCardFile) formData.append('manager_id_card_file', data.manager.idCardFile);
  if (data.manager?.idCardBackFile)
    formData.append('manager_id_card_back_file', data.manager.idCardBackFile);
  formData.append(
    'payment',
    JSON.stringify(snakeCaseKeys(data.payment as unknown as Record<string, unknown>)),
  );
  if (data.comments) formData.append('comments', data.comments);
  if (id) formData.append('_method', 'PUT');
  return post(`reservations${!id ? '' : `/${id}`}`, formData, { transformRequest: () => formData });
};

export const softDelete = (id: string): Promise<AxiosResponse> => remove(`reservations/${id}`);
